export default {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  isRoot: state => state.user && state.user.isRoot,
  canConnectToSocket: state => state.canConnectToSocket,
  getUserSocketConnection: state => state.userSocketConnection,
  getIntegratorSocketConnection: state => state.integratorSocketConnection,
}
